<template>
  <div id="widget">
    <div id="unmudl-widget">
      <template v-if="isAuthenticated">
        <div v-if="programs && programs.length > 0">
          <unmudl-explore-program-list
            :type="type"
            :programs="programs"
            :institution-id="targetInstitutionId"
            :course-title="courseTitle">
          </unmudl-explore-program-list>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import '../assets/theme/default/sass/global.scss'
  //import '../assets/theme/default/css/defaultTheme.min.css'
  import '../assets/module/css/explore/explore.min.css'
  import UnmudlExploreProgramList from './widget/components/UnmudlExploreProgramList'

  export default {
    name: 'unmudl-web-widget-app',
    components: {
      UnmudlExploreProgramList
    },
    data: () => {
      return {
        key: '',
        secret: '',
        orgId: null,
        userId: null,
        courseId: null,
        firstName: null,
        lastName: null,
        programs: [],
        type: null,
        courseTitle: null,
        institutionId: '',
        targetInstitutionId: '',
        isAuthenticated: false,
        selectedProgram: null,
        showProgressPopover: false,
        progressPopoverTargetId: null
      }
    },

    mounted () {
      if (this.$route.query) {
        this.key = this.$route.query.key
        this.secret = this.$route.query.secret
        this.orgId = this.$route.query.orgId
        this.courseId = this.$route.query.courseId
        window.addEventListener('message', (event) => {
          if (event.data.name === 'AfterLogIn') {
            let data = event.data.data
            this.userId = data.id
            this.firstName = data.firstName
            this.lastName = data.lastName
          }
        })

        if (this.$route.query.userId && this.$route.query.userId.length > 1) {
          window.parent.postMessage({name: 'WidgetLogin'}, '*')
          setTimeout(() => { this.authenticateWidget() }, 2000)
        } else {
          this.authenticateWidget()
        }
      }
    },

    methods: {
      ...mapActions([
        'loadAuthenticateWidget',
        'loadLoginUnmudlUser',
        'loadCourseProgramProgress'
      ]),

      async loginUnmudlUser () {
        let data = {
          orgId: this.orgId,
          userId: this.userId,
          firstName: this.firstName,
          lastName: this.lastName
        }
        let userObj = await this.loadLoginUnmudlUser({institutionId: this.institutionId, data: data})
        if (userObj && userObj.uuid) {
          this.targetInstitutionId = userObj.institutionId
          this.getCourseProgramProgress()
        }
      },

      authenticateWidget () {
        this.loadAuthenticateWidget({key: this.key, secret: this.secret}).then(institutionId => {
          if (institutionId) {
            this.institutionId = institutionId
            this.loginUnmudlUser()
          } else {
            this.isAuthenticated = false
          }
        })
      },

      getCourseProgramProgress () {
        this.loadCourseProgramProgress({courseId: this.courseId, institutionId: this.targetInstitutionId}).then(resp => {
          window.parent.postMessage({name: 'RemoveLoader'}, '*')
          if (resp && resp.programs && resp.programs.length > 0) {
            this.isAuthenticated = true
            this.type = (resp.type) ? resp.type : 'course'
            this.courseTitle = resp.courseTitle
            this.programs = resp.programs
            this.programs.forEach((program, i) => {
              program.progress.values.push({label: 'credits selected', value: program.selectedCredit})
              program.progress.values.forEach((progress, x) => {
                if (progress.label === 'credits needed') {
                  progress.value -= program.selectedCredit
                }
                if (progress.value < 0) {
                  progress.value = 0
                }
              })
              program.progress.courseValues.push({label: 'courses selected', value: program.selectedCredit})
              program.progress.courseValues.forEach((progress, y) => {
                if (progress.label === 'courses needed') {
                  progress.value -= program.selectedCredit
                }
                if (progress.value < 0) {
                  progress.value = 0
                }
              })
              program.completion = this.calculateCompletion(program)
            })
          }
        })
      },

      calculateCompletion (program) {
        if (program.progress) {
          let value = ((program.selectedCredit + program.progress.completed) / program.progress.total) * 100
          if (value > 100) {
            value = 100
          }
          return Math.ceil(value)
        }
        return 0
      }
    }
  }
</script>

<style scoped>
  body {
    overflow: hidden;
  }
  ::-webkit-scrollbar {
    height: 0px;
    width: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/app/UnmudlWebWidgetApp.vue